import { Avatar, Center } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Campaign, Targeting } from '@feathr/blackbox';
import { CardV2 as Card, EmptyState } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';
import type { ListResponse } from '@feathr/rachis';

interface IProps {
  campaign: Campaign;
  targetings: ListResponse<Targeting>;
}

function NewAudience({ campaign, targetings }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const isLoading = campaign.isPending || targetings.isPending;

  const prefix = (
    <Center>
      <Avatar color={'slate.5'} mb={'2'} size={'80'}>
        {getIconForAction('userGroup')}
      </Avatar>
    </Center>
  );

  return (
    <Card>
      <Card.Header title={t('New Audience')} />
      <Card.Content isLoading={isLoading} skeleton={{ options: { paragraphs: 3 } }}>
        <EmptyState
          description={t(
            'Create your audience by adding location, demographic, and interest filters to reach the right people.',
          )}
          label={t('No audience selected')}
          prefix={prefix}
          theme={'slate'}
        />
      </Card.Content>
    </Card>
  );
}

export default observer(NewAudience);
